import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../redux/features/auth/authSlice';
import staffReducer from '../redux/features/staff/staffSlice';
import courseReducer from '../redux/features/course/courseSlice';
import bulkReducer from '../redux/features/bulkUpload/bulkUploadSlice';
import certificateReducer from '../redux/features/certificate/certificateSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    staff: staffReducer,
    course: courseReducer,
    bulk: bulkReducer,
    certificate: certificateReducer,
  },
});

export default store;
